module.exports = __webpack_public_path__ + "components/flag/static/square/fk-43dd0a62ad0c38d2663671a855ac2c45.svg";